import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { alpha, useTheme } from "@mui/material/styles";
import React from "react";
import { useSeason } from "./SeasonContext";

const SeasonSelect: React.FC = () => {
  const { seasons, selectedSeason, setSelectedSeason } = useSeason();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Select
        value={selectedSeason}
        onChange={(e) => setSelectedSeason(e.target.value)}
        size="small"
        sx={{
          minWidth: { xs: 100, sm: 140, md: 160 },
          backgroundColor: alpha("#ffffff", 0.88),
          borderRadius: 999,
          boxShadow: `0 10px 22px ${alpha("#c9d8e7", 0.18)}`,
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          color: "text.primary",
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: alpha(theme.palette.text.primary, 0.08),
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: alpha(theme.palette.primary.main, 0.18),
          },
        }}
      >
        {seasons.map((season) => (
          <MenuItem key={season.id} value={season.id.toString()}>
            {season.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default SeasonSelect;
